import React from "react";
import {
  Chip,
  Grid,
  Divider
} from "@mui/material";
import {
   SectionInput
} from "../MainInfo";

class SeoMeta extends React.PureComponent {

  onChangForm = (locale, name, value) => {
    let values = {...this.props.values};
    values[locale][name] = value;
    this.props.onChange(values);
  }

  render () {
    const {
      values
    } = this.props;

    return (
      <Grid container spacing={1}>

        {/* RU */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="RU"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['ru']['meta_title']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['ru']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['ru']['meta_description']}
            onChange={this.onChangForm.bind(this, 'ru', 'meta_description')}
          />
        </Grid>

        {/* EN */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="EN"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['en']['meta_title']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['en']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['en']['meta_description']}
            onChange={this.onChangForm.bind(this, 'en', 'meta_description')}
          />
        </Grid>

        {/* KAZ */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="KAZ"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Title"
            value={values['kaz']['meta_title']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_title')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Keywords"
            value={values['kaz']['meta_keywords']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_keywords')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionInput
            title="SEO Description"
            value={values['kaz']['meta_description']}
            onChange={this.onChangForm.bind(this, 'kaz', 'meta_description')}
          />
        </Grid>

      </Grid>
    )
  }
}

export default SeoMeta
